var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_8372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8146 0.00104242H1.18069C0.536312 -0.00620758 0.007875 0.50998 0 1.15435V14.8452C0.007625 15.4899 0.536 16.0065 1.18062 15.9998H14.8146C15.4606 16.0078 15.9911 15.4911 16 14.8452V1.15329C15.9908 0.507667 15.4603 -0.00845758 14.8146 -2.0077e-05",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 13.6328H11.2621V9.92014C11.2621 9.03482 11.2463 7.89514 10.0291 7.89514C8.79431 7.89514 8.60538 8.85976 8.60538 9.8557V13.6326H6.23475V5.99782H8.51056V7.0412H8.54244C8.77019 6.65176 9.09931 6.33139 9.49474 6.11421C9.89017 5.89702 10.3371 5.79116 10.7879 5.80789C13.1908 5.80789 13.6338 7.38839 13.6338 9.44451L13.6328 13.6328ZM3.55975 4.95426C2.79994 4.95439 2.18387 4.33851 2.18375 3.5787C2.18362 2.81889 2.79944 2.20282 3.55925 2.2027C4.31906 2.20251 4.93512 2.81839 4.93525 3.5782C4.93532 3.94308 4.79044 4.29304 4.53248 4.5511C4.27453 4.80916 3.92463 4.95418 3.55975 4.95426ZM4.74512 13.6329H2.37194V5.99782H4.74506V13.6328L4.74512 13.6329ZM14.8146 0.00101191H1.18069C0.536312 -0.00623809 0.007875 0.509949 0 1.15432V14.8451C0.007625 15.4898 0.536 16.0065 1.18062 15.9998H14.8146C15.4606 16.0078 15.9911 15.4911 16 14.8451V1.15326C15.9908 0.507637 15.4603 -0.0084881 14.8146 -5.05946e-05",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_8372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.342c90f5fb6f2d40fb421fc5041f287c.svg";
export { ForwardRef as ReactComponent };